/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFileMov = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M20 7.586v3.44h-2V9h-5V4H6v16h12v-1h2v3H4V2h10.414zM15 7h1.586L15 5.414z" />
        <path d="M16.287 12.965c.389 0 .72.081.993.243.274.158.482.388.626.69.144.303.216.67.216 1.101 0 .65-.158 1.155-.474 1.51-.317.353-.771.53-1.36.53-.587-.001-1.04-.177-1.36-.53-.317-.355-.475-.859-.475-1.51 0-.432.072-.798.216-1.1a1.54 1.54 0 0 1 .626-.691c.273-.162.604-.243.992-.243zm0 .718c-.327 0-.572.113-.733.34-.159.223-.238.548-.238.976s.08.756.238.982c.161.227.406.34.733.34.327 0 .57-.113.729-.34.162-.226.243-.554.243-.982s-.081-.753-.243-.977c-.159-.226-.402-.34-.729-.34zm-4.572 1.942 1.228-2.584h.88v3.922h-.83v-2.541l-1.037 2.163h-.517l-1.037-2.129v2.507h-.814V13.04h.88zm8.458.304.927-2.888h.912l-1.447 3.922h-.814l-1.446-3.922h.95z" />
      </g>
    </g>
  </Icon>
);
export { SvgFileMov as FileMov };
